require('./retailLoanProductAsideInfo.scss');
require('./retailLoanProductAsideInfo.override.scss');

//@vendor
const React = require('react');
const PropTypes = require('prop-types');
// @core
const { FormattedText } = require('core/i18n').i18n;
// //@utilities
const { getFormattedString, decimalsLength } = require('utilities/currencyHelper');
const { isRetailAddressDelivery } = require('../../../../../loansUtilities/loansHelper');
// //@commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
// //@components
const { RetailLoanOfferType } = require('../../retailLoanOfferType/retailLoanOfferType');
const { RetailDeliveryInfoBoxAside } = require('../../retailDeliveryInfoBoxAside/retailDeliveryInfoBoxAside');

const buildMinimumQuota = (immItem, immRetailLoan) => {
    const currency = immRetailLoan.get('currency');
    const quota = getFormattedString({
        amount: immItem.get('field_value_minimum_quota'),
        currency: currency,
        decimalsLength: decimalsLength(immItem.get('field_value_minimum_quota'))
    });
    const maxTerm = 48;
    const price = getFormattedString({
        amount: immItem.get('field_total_product_price'),
        currency: currency,
        decimalsLength: decimalsLength(immItem.get('field_total_product_price'))
    });
    const formattedQuota = `<span class="retail-loan-product__info-quota--quota">${quota}</span>`;
    const haveCommercialText = !!immItem.get('field_commercial_text_web') ? 'retail-loan-product-aside-info__content-minimum-quota--is-adress' : '';

    return (
        <div className={`retail-loan-product-aside-info__content-minimum-quota ${haveCommercialText}`}>
            <div>
                <FormattedText
                    className="retail-loan-product-aside-info__quota retail-loan-product-aside-info__quota--quota"
                    value="retailLoanCatalog-retailLoanCatalog_dateEstimatedDelivery5"
                    injectedStrings={[formattedQuota]}
                />
            </div>
            <div>
                <FormattedText
                    className="retail-loan-product-aside-info__quota"
                    value="retailLoanCatalog-retailLoanCatalog_feesAmount"
                    injectedStrings={[maxTerm]}
                />
            </div>
            <div>
                <FormattedText
                    className="retail-loan-product-aside-info__quota retail-loan-product-aside-info__quota--pvp"
                    value="retailLoanCommon-retailLoanCommon_pvp"
                    injectedStrings={[price]}
                />
            </div>
        </div>
    );
}

const buildRetailInfoBox = (labels, immItem) => {
    const isAddress = isRetailAddressDelivery(immItem.get('field_pickup_option'));

    return (
        <RetailDeliveryInfoBoxAside
            isAddress={isAddress}
            labels={labels}
        />
    )
}

const buildDealerListLink = (immItem, onHandleOpenModalListDealers) => {
    const isAddress = isRetailAddressDelivery(immItem.get('field_pickup_option'));

    const checkTheLinkText = (
        <FormattedText
            className="retail-loan-product-aside-info__quota"
            value="retailLoanCatalog-retailLoanCatalog_checkThe"
        />);

    const dealerListLink = (
        <OKLink
            modifier="emphasize"
            onClick={onHandleOpenModalListDealers}
        >
            <FormattedText value="retailLoanCatalog-retailLoanCatalog_dealerListLink" />
        </OKLink>
    )
    return !isAddress ? (
        <div className="retail-loan-product-aside-info__link col-xs-12">
            {checkTheLinkText} {dealerListLink}
        </div>
    ) : null;
}

const RetailLoanProductAsideInfo = (props) => {

    const { immItem, immRetailLoan, labels, onHandleOpenModalListDealers, onHandleToggleModal, highlightText } = props;
    const retailLoanOfferType = <RetailLoanOfferType highlightText={highlightText} />;

    return (
        <div className="retail-loan-product-aside-info">
            {retailLoanOfferType}
            {buildMinimumQuota(immItem, immRetailLoan)}
            <div className="row">
                <div className="col-xs-12">
                    {buildRetailInfoBox(labels, immItem)}
                </div>
                {buildDealerListLink(immItem, onHandleOpenModalListDealers)}
                <div className="retail-loan-product-aside-info__continue col-xs-12">
                    <OKButton
                        modifier="primary"
                        onClick={() => onHandleToggleModal()}
                    >
                        {labels.continue}
                    </OKButton>
                </div>
            </div>
        </div>
    );
}

RetailLoanProductAsideInfo.propTypes = {
    immItem: PropTypes.object,
    immRetailLoan: PropTypes.object.isRequired,
    labels: PropTypes.object.isRequired,
    onHandleOpenModalListDealers: PropTypes.func,
    onHandleToggleModal: PropTypes.func,
    highlightText: PropTypes.string,
};

export { RetailLoanProductAsideInfo };
